import { ColumnDef } from "@tanstack/react-table"
import { DataTableColumnHeader } from "../../shared/table/TableColumnHeader"
import { SelectCustomer, Transaction } from "@/database/schema"
import { TransactionsTableRowActions } from "./TransactionRowActions"
import { formatPrice } from "@/utils"
import { currenciesMap } from "@/components/invoiceArea/currencies"
import { Link, useSearchParams } from "react-router-dom"

export const transactionsColumns: ColumnDef<Transaction>[] = [
    {
        id: "select",
        header: ({ table }) => (
            <input style={{ display: "flex", width: "100%", justifyContent: "center", cursor: "pointer", boxShadow: "none" }}
                checked={table.getIsAllPageRowsSelected()}
                onChange={() => {
                    if (table.getIsAllPageRowsSelected()) {
                        table.toggleAllPageRowsSelected(false);
                    } else {
                        table.toggleAllPageRowsSelected(true);
                    }
                }}
                aria-label="Select all"
                type="checkbox"
            />
        ),
        cell: ({ row }) => (
            <input style={{ display: "flex", width: "100%", justifyContent: "center", cursor: "pointer", boxShadow: "none" }}
                checked={row.getIsSelected()}
                onChange={(event) => row.toggleSelected(event.target.checked)}
                onClick={(e) => e.stopPropagation()}
                aria-label="Select row"
                type="checkbox"
            />
        ),
        size: 4,
        minSize: 4,
        enableSorting: false,
        enableHiding: false,
    },
    {
        accessorKey: "id",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Id" table={table} />
        ),
        cell: ({ row }) => <div className="table__cell-item" >
            {row.getValue("id")}
        </div>,
        enableHiding: false,
        size: 10,
        minSize: 10,
    },
    {
        accessorKey: "amount",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Amount" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div className="table__cell-item">
                    <span>
                        {currenciesMap.get(row.original.currency)?.symbol}
                        {formatPrice(row.getValue("amount"))}
                    </span>
                </div>
            )
        },
        size: 22.5,
        minSize: 22.5,
    },
    {
        accessorKey: "invoiceNumber",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Invoice #" table={table} />
        ),
        cell: ({ row }) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const [searchParams] = useSearchParams();
            return (
                <div className="table__cell-item">
                    <Link className="table__table-link" to={{
                        pathname: "/preview",
                        search: `template=${row.original.invoiceNumber}`
                    }} state={{ prevPath: `/transactions?${searchParams.toString()}` }}>
                        Invoice {row.getValue("invoiceNumber")}
                    </Link>
                </div>
            )
        },
        filterFn: ({ original }, _id, value) => {
            return value.includes(original.invoice.invoiceNumber);
        },
        size: 18.5,
        minSize: 18.5,
    },
    {
        accessorKey: "customer",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Customer" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div className="table__cell-item">
                    <span>
                        {(row.getValue("customer") as SelectCustomer).name}
                    </span>
                </div>
            )
        },
        sortingFn: (a, b) => {
            return a.original.customer.name.localeCompare(b.original.customer.name);
        },
        filterFn: ({ original }, _id, value) => {
            return value.includes(original.customer.name);
        },
        size: 23,
        minSize: 23,
        enableSorting: true
    },
    {
        accessorKey: "date",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Date" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div className="table__cell-item">
                    <span>
                        {row.getValue("date")}
                    </span>
                </div>
            )
        },
        size: 18.5,
        minSize: 18.5,
    },
    {
        id: "actions",
        cell: ({ row, table }) => <TransactionsTableRowActions row={row} table={table} />,
        size: 4,
        minSize: 4,
    },
]